import { Component, OnInit } from "@angular/core";
import { JsLoaderService } from "src/shared/services/js-loader.service";

@Component({
  selector: "app-clinic-visits",
  templateUrl: "./clinic-visits.component.html"
})
export class ClinicVisitsComponent implements OnInit {
  constructor(private jsLoader: JsLoaderService) {
    this.jsLoader.loadScripts();
  }

  ngOnInit() {}
}
